export const LAB = {
  name: "Lifeline Diagnostics",
  tagline: "ISO Certified Diagnostic Laboratory — Jaysingpur, since 2010.",
  proprietor: "Dr. Neelam Attar",
  proprietorCred: "MBBS, MD (Microbiology)",
  address:
    "Shop No. 2, Rising Sun Apartment, 8th Lane, Near Vairan Adda, Behind School No. 1, Jaysingpur.",
  phone: "+91 7744999622",
  phoneHref: "tel:+917744999622",
  phone2: "+91 7219789622",
  phone2Href: "tel:+917219789622",
  email: "lifelineattar@gmail.com",
  emailHref: "mailto:lifelineattar@gmail.com",
  mapsUrl:
    "https://www.google.com/maps/place/LIFELINE+DIAGNOSTICS/@16.7799422,74.5521081,17z/data=!3m1!4b1!4m6!3m5!1s0x3bc11fa44d0f880b:0xb7a72df2ab65cfca!8m2!3d16.7799422!4d74.5521081!16s%2Fg%2F11st_s1ybk",
  mapsEmbed:
    "https://www.google.com/maps?q=LIFELINE+DIAGNOSTICS+Jaysingpur&output=embed",
  established: "2010",
  images: {
    logo:
      "https://customer-assets-agu9un31.emergentagent.net/job_194d2481-9a39-4faa-a195-11de52f30c81/artifacts/elzv0pey_1786891696373-1ece5ba8-ab46-41b7-9d90-e819eace615e_1.jpg",
    front:
      "https://customer-assets-agu9un31.emergentagent.net/job_194d2481-9a39-4faa-a195-11de52f30c81/artifacts/yhywffzf_labbbbbbb.webp",
    interior:
      "https://customer-assets-agu9un31.emergentagent.net/job_194d2481-9a39-4faa-a195-11de52f30c81/artifacts/c5hgcvwu_lab2.webp",
  },
  services: [
    "Microbiology",
    "Biochemistry",
    "Pathology",
    "Serology",
    "Hematology",
    "Water & Environmental Testing",
    "Hospital Infection Control",
    "Antimicrobial Stewardship",
  ],
};
